import React from 'react';
import { AlertCircle, HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="bg-[#111111] py-20 px-4 border-y border-gray-900 pt-[20px] pb-[20px]" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <div className="flex items-start gap-4 mb-[22px]" data-id="element-86">
          <div className="p-3 bg-red-900/20 rounded-full" data-id="element-87">
            <HeartCrack className="w-8 h-8 text-red-500" data-id="element-88" />
          </div>
          <div data-id="element-89">
            <h2 className="font-bold mb-4 text-[24px]" data-id="element-90">The "Heartbreak"</h2>
            <div className="h-1 w-20 bg-red-600 mb-6" data-id="element-91"></div>
          </div>
        </div>

        <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-92">
          <p data-id="element-93">
            Your home should be a sanctuary, but right now it’s a battlefield
          </p>
          <p data-id="element-94">
            Whether the conflict is new or years old, your cats are living in
            constant fear and betrayal.
          </p>

          <div className="bg-gray-900 p-6 border-l-4 border-red-600 my-8" data-id="element-95">
            <p className="font-medium text-white" data-id="element-96">
              You’re exhausted, stressed, and afraid of the worst-case scenario.
            </p>
          </div>

          <p data-id="element-97">
            Wait. Before you lose hope, you need to understand one thing:{' '}
            <span className="text-white font-bold" data-id="element-98">
              Your cats aren't 'mean'.
            </span>{' '}
            They are just biological prisoners of their territorial instincts.
          </p>
        </div>
      </div>
    </section>;
}